import React, { useState } from 'react';
import { Image } from 'react-native';
import type { PodcastProps } from '../../../types';
import { SocialPodcastHelpers } from '../../api';
import { PodcastApi } from '../api';
import { Button, Text, View } from '../../../Components/Themed';

type ClaimPodcastModalProps = {
    podcast:PodcastProps,
    width:number,
    onClose:() => void,
    onPodcastUpdate:(pod:PodcastProps) => void
}

const ClaimPodcastModal = ({ podcast, onClose, onPodcastUpdate }:ClaimPodcastModalProps) => {
    const [ loading, setLoading ] = useState(false);

    const handleClaimPodcast = async() => {
        setLoading(true);
        const updated_pod = await PodcastApi.claimPodcast(podcast.podcast_id);
        if(!updated_pod){ return alert('Unable to process claim, please try again later.') }
        onPodcastUpdate(updated_pod)
        setLoading(false);
    }

    return (
        <View float>
            <View type='header' style={{ flexDirection:'row', borderTopRightRadius:8, borderTopLeftRadius:8, padding:10 }}>
                <Image
                    source={{ uri: SocialPodcastHelpers.getPodcastImage(podcast) }}
                    style={{ width:50, height:50, borderRadius:4 }}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>Is this your podcast?</Text>
                    <Text style={{ marginTop:3 }} theme='description'>Claim this podcast and get it prioritized over other similar podcasts!</Text>
                </View>
            </View>
            <View type='body' style={{ padding:10 }}>
                <Text style={{ marginBottom:10 }} theme='h1'>Benefits of claiming podcast</Text>
                <View type='row' style={{  alignItems:'flex-start', padding:5 }}>
                    <Text size={40} weight='bold'>*</Text>
                    <Text style={{ marginLeft:10 }} theme='h2'>PodQuest, BettorEdge's proprietary podcast recommendation engine will suggest your podcast to interested parties based on their betting history!</Text>
                </View>
                <View type='row' style={{ alignItems:'flex-start', paddingTop:5 }}>
                    <Text size={40} weight='bold'>*</Text>
                    <Text style={{ marginLeft:10 }} theme='h2'>Adds the podcast to your profile for people to see your bets, takes, and podcasts all in one place!</Text>
                </View>
                <View type='row' style={{ alignItems:'flex-start', paddingTop:5 }}>
                    <Text size={40} weight='bold'>*</Text>
                    <Text style={{ marginLeft:10 }} theme='h2'>Additionally, it gets you a referral code allowing you to make money on users sent to BettorEdge!</Text>
                </View>
            </View>
            <View style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                <Button
                    title='No Thanks'
                    style={{flex:1}}
                    type='error'
                    onPress={() => onClose()}
                />
                 <Button
                    title='Request Claim'
                    style={{flex:2, marginLeft:5, opacity:loading?0.5:1}}
                    type='success'
                    disabled={loading}
                    onPress={() => handleClaimPodcast()}
                />
            </View>
        </View>
    )
}

export default ClaimPodcastModal
